var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _circle, _circle2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGelimigrafikveanalizaralar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "39.76 29.91 18.46 18.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3967af;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.92,46.47h-.32v-9.23c0-.18-.14-.32-.32-.32h-.64c-.18,0-.32.14-.32.32s.14.32.32.32h.32v8.91h-15.92v-8.91h.32c.18,0,.32-.14.32-.32s-.14-.32-.32-.32h-.64c-.18,0-.32.14-.32.32v9.23h-.32c-.18,0-.32.14-.32.32,0,.88.71,1.59,1.59,1.59h15.28c.88,0,1.59-.71,1.59-1.59,0-.18-.14-.32-.32-.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.64,42.01h12.73c.18,0,.32-.14.32-.32v-11.46c0-.18-.14-.32-.32-.32h-12.73c-.18,0-.32.14-.32.32v11.46c0,.18.14.32.32.32ZM42.96,31.83h12.1v9.55h-12.1v-9.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.1,40.1h-.32v-3.5c0-.18-.14-.32-.32-.32s-.32.14-.32.32v3.5h-.64v-2.23c0-.18-.14-.32-.32-.32s-.32.14-.32.32v2.23h-.32c-.18,0-.32.14-.32.32s.14.32.32.32h2.55c.18,0,.32-.14.32-.32s-.14-.32-.32-.32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.37,36.28h3.18c.18,0,.32-.14.32-.32,0-1.93-1.57-3.5-3.5-3.5-.18,0-.32.14-.32.32v3.18c0,.18.14.32.32.32ZM48.69,33.12c1.32.15,2.38,1.2,2.53,2.53h-2.53v-2.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.28,36.91h-2.86v-2.86c0-.18-.14-.32-.32-.32-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5,3.5-1.57,3.5-3.5c0-.18-.14-.32-.32-.32ZM44.24,37.23c0-1.47,1.11-2.69,2.55-2.85v2.74l-1.64,2.19c-.55-.52-.9-1.27-.9-2.09ZM47.1,40.1c-.53,0-1.02-.14-1.45-.39l1.61-2.15h2.69c-.16,1.43-1.38,2.55-2.85,2.55Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.33,
    y: 43.29,
    width: 3.18,
    height: 1.91,
    rx: 0.32,
    ry: 0.32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.51,
    y: 43.29,
    width: 3.18,
    height: 1.91,
    rx: 0.32,
    ry: 0.32
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.46,
    cy: 44.24,
    r: 0.32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.56,
    cy: 44.24,
    r: 0.32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.42,
    y: 43.29,
    width: 3.18,
    height: 1.91,
    rx: 0.32,
    ry: 0.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGelimigrafikveanalizaralar);
export default __webpack_public_path__ + "static/media/icon_gelişmiş grafik ve analiz araçları.90210fee2ae7ed32b867e41ebe89f605.svg";
export { ForwardRef as ReactComponent };